import { descriptorsFactory } from '../../utils/filters';

export const isBlackFridayDescriptor = descriptorsFactory({
  name: 'isBlackFriday',
  clear: ['is_black_friday'],
})(
  {
    form: [
      {
        key: 'is_black_friday',
        type: 'term',
        value: true,
      },
    ],
    label: 'Чёрная пятница',
    state: 'On',
  },
  {
    form: [],
    label: 'Чёрная пятница',
    state: 'Off',
  },
);
